module.exports = "p {\n  color: white; }\n\n.f {\n  background-color: black;\n  color: white; }\n"